import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AttendanceService = {
    getAttendanceChannels: async () => axios.get(API_URL + "/despacho/getAttendanceChannels").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    getAttendanceSectors: async () => axios.get(API_URL + "/despacho/getAttendanceSectors").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default AttendanceService;